import { BaseShowCardElementMixin } from "%/dynamic-component-editor/standard-components/base-show-card/base-show-card-element-mixin";

export const ShowCardSmallElementMixin = {
  extends: BaseShowCardElementMixin,
};
